// src/Modules/User/Domain/UseCase/LoginUseCase.ts
import { AuthRepository } from '../Repositories/AuthRepository';
import { AuthTokens, User } from '../../Model/User';
import { api } from '../../../../api/axiosInstance';   // 공통 axios 인스턴스

export class LoginUseCase {
  constructor(private repo: AuthRepository) {}

  async execute(
    username: string,
    password: string,
  ): Promise<{ tokens: AuthTokens; user: User }> {
    /* 1️⃣ 로그인 → access / refresh 수령 */
    const tokens = await this.repo.login(username, password);

    /* 2️⃣ 새 access 를 헤더에 일시 주입하여 /auth/me 가 인증되도록 함 */
    api.defaults.headers.common['Authorization'] = `Bearer ${tokens.access}`;

    /* 3️⃣ 사용자 정보 조회 */
    const user = await this.repo.me();

    return { tokens, user };
  }
}
